import { render, staticRenderFns } from "./moderation.vue?vue&type=template&id=a1a8e18a&scoped=true"
import script from "./moderation.vue?vue&type=script&lang=js"
export * from "./moderation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a8e18a",
  null
  
)

export default component.exports